<template>
  <path
    d="M2.5 2C2.22386 2 2 2.22386 2 2.5V13.5C2 13.7761 2.22386 14 2.5 14H13.5C13.7761 14 14 13.7761 14 13.5L14 10C14 9.72386 14.2239 9.5 14.5 9.5C14.7761 9.5 15 9.72386 15 10L15 13.5C15 14.3284 14.3284 15 13.5 15H2.5C1.67157 15 1 14.3284 1 13.5V2.5C1 1.67157 1.67157 1 2.5 1H6C6.27614 1 6.5 1.22386 6.5 1.5C6.5 1.77614 6.27614 2 6 2H2.5Z"
    fill="currentColor" />
  <path
    d="M14 2.70709V6.5C14 6.77614 14.2239 7 14.5 7C14.7761 7 15 6.77614 15 6.5V1.5C15 1.22386 14.7761 1 14.5 1H9.5C9.22386 1 9 1.22386 9 1.5C9 1.77614 9.22386 2 9.5 2H13.2929L5.5269 9.76597C5.33164 9.96124 5.33164 10.2778 5.5269 10.4731C5.72217 10.6683 6.03875 10.6683 6.23401 10.4731L14 2.70709Z"
    fill="currentColor" />
</template>
